import { AuthInstance } from "../../utils/axiosConfig";
import { setErrors } from "../Error/actions";
import { resetErrors } from "../Error/epics";
import { setLoading } from "../Common/actions";
import * as epics from "./epics";
import { orderType } from "../../lookups/status";

export const fetchPackages = () => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(resetErrors());
      let response = await AuthInstance.get(`consultation/packages`);
      let data = await response.data;
      dispatch(epics.setPackages(data.payload.data));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setErrors(error));
      dispatch(setLoading(false));
    }
  };
};

export const createOrder = (navigate, packageId, companyId) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(resetErrors());

      let response = await AuthInstance.post(`orders/`, {
        company_id: companyId,
        items: [{ item_id: packageId, product_type: "CONSULTATION" }],
      });
      let data = await response.data;
      if (data.payload.data.id) {
        navigate(
          `/${companyId}/payment/${data.payload.data.id}/method?type=${orderType.consultation}`
        );
      }
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setErrors(error));
      dispatch(setLoading(false));
    }
  };
};

export const fetchConsultationOrder = (
  navigate,
  orderId,
  companyId,
  currentStatus
) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(resetErrors());
      let response = await AuthInstance.get(`orders/${orderId}`);
      let data = await response.data;
      dispatch(epics.setConsultationOrder(data?.payload?.data));
      if (currentStatus && data.payload.data.status !== currentStatus) {
        navigate(`/${companyId}`);
      }
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setErrors(error));
      dispatch(setLoading(false));
    }
  };
};
export const fetchConsultationRequest = (uuid) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(resetErrors());
      let response = await AuthInstance.get(`consultation/requests/${uuid}`);
      let data = await response.data;
      dispatch(epics.setConsultationRequest(data?.payload?.data));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setErrors(error));
      dispatch(setLoading(false));
    }
  };
};
export const fetchConsultationRequests = (companyId) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(resetErrors());
      let response = await AuthInstance.get(
        `consultation/requests/?company_id=${companyId}`
      );
      let data = await response.data;

      dispatch(epics.setConsultationRequests(data.payload.data));

      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setErrors(error));
      dispatch(setLoading(false));
    }
  };
};
